import { SessionStorage } from '@witkac/kartamiejska-shared';
import { ApolloLink, HttpLink, from, InMemoryCache } from 'apollo-boost';
import { ApolloClient } from 'apollo-client';
import Vue from 'vue';
import VueApollo from 'vue-apollo';

import { config } from './utils/config';
import { UNAUTHORIZED_MESSAGES } from './utils/constants';
import router from './router';

Vue.use(VueApollo);

const httpLink = new HttpLink({ uri: config.graphQLURL });

const tokenApplyMiddleware = new ApolloLink((operation, forward) => {
  if (forward) {
    const token = sessionStorage.getItem(SessionStorage.TOKEN);
    if (token) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${token}`
        }
      });
    }
    return forward(operation);
  }
  return null;
});

const tokenRefreshMiddleware = new ApolloLink((operation, forward) => {
  if (forward) {
    return forward(operation).map(response => {
      const context = operation.getContext();
      const headers = context.response.headers;
      if (headers) {
        const newToken = headers.get('token');
        if (newToken) {
          sessionStorage.setItem(SessionStorage.TOKEN, newToken);
        }
      }

      return response;
    });
  }
  return null;
});

const unauthorizedMiddleware = new ApolloLink((operation, forward) => {
  if (forward) {
    return forward(operation).map(response => {
      if (
        response.errors &&
        response.errors.some(graphQlError => UNAUTHORIZED_MESSAGES.includes(graphQlError.message))
      ) {
        localStorage.clear();
        router.push({ name: 'login' });
      }

      return response;
    });
  }
  return null;
});

export const apolloClient = new ApolloClient({
  link: from([unauthorizedMiddleware, tokenApplyMiddleware, tokenRefreshMiddleware, httpLink]),
  cache: new InMemoryCache({ resultCaching: false })
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

export default apolloProvider;
